module.exports = __webpack_public_path__ + "static/icon_qd.3243c6b1.png";